import ApplicationController from "../../../application_controller.js"

export default class extends ApplicationController {
    static values = { hasToggleButton: Boolean }
    static targets = ["modalWithBackdrop", "dialog"]

    backdropPointerDown = false;

    async connect() {
        super.connect()
        this.keydownHandler = this.handleKeydown.bind(this)
        document.addEventListener('keydown', this.keydownHandler)
        await this.setZIndex(this.modalWithBackdropTarget)
        if (this.hasToggleButtonValue === false) {
            this.showModal()
        }
    }

    disconnect() {
        document.removeEventListener('keydown', this.keydownHandler)
    }

    onBackdropPointerDown(event) {
        this.backdropPointerDown = (event.target === event.currentTarget);
    }

    onBackdropPointerUp(event) {
        // Only close if pointerdown and pointerup were both on the backdrop
        if (this.backdropPointerDown && event.target === event.currentTarget) {
            this.closeModal();
        }

        this.backdropPointerDown = false;
    }

    openModal() {
        if (this.hasToggleButtonValue === true) {
            this.previouslyFocusedElement = document.activeElement
            this.showModal()
        }
    }

    closeModal() {
        const elementToFocus = this.previouslyFocusedElement

        if (this.hasToggleButtonValue === true) {
            this.modalWithBackdropTarget.classList.add('hidden')
        } else {
            const emptyDiv = document.createElement('div')
            if (this.element.id) {
                emptyDiv.id = this.element.id
            }
            this.element.replaceWith(emptyDiv)
        }

        if (elementToFocus?.isConnected) elementToFocus.focus()
        this.previouslyFocusedElement = null
    }

    showModal() {
        this.modalWithBackdropTarget.classList.remove('hidden')
        this.dialogTarget.focus({ preventScroll: true })
    }

    handleKeydown(event) {
        if (event.defaultPrevented || this.modalWithBackdropTarget.classList.contains('hidden')) return
        if (!this.ownsKeyboardEvent(event)) return

        if (event.key === 'Escape') {
            if (this.dialogTarget.querySelector('[aria-haspopup="menu"][aria-expanded="true"]')) return

            event.preventDefault()
            this.closeModal()
        } else if (event.key === 'Tab') {
            this.trapFocus(event)
        }
    }

    ownsKeyboardEvent(event) {
        const closestDialog = event.target?.closest?.('[role="dialog"]')
        return !closestDialog || closestDialog === this.dialogTarget
    }

    trapFocus(event) {
        const focusableElements = Array.from(this.dialogTarget.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter(element => element.getClientRects().length > 0)

        if (focusableElements.length === 0) {
            event.preventDefault()
            this.dialogTarget.focus()
            return
        }

        const firstElement = focusableElements[0]
        const lastElement = focusableElements[focusableElements.length - 1]

        if (event.shiftKey && [this.dialogTarget, firstElement].includes(document.activeElement)) {
            event.preventDefault()
            lastElement.focus()
        } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault()
            firstElement.focus()
        }
    }
}
